<template>
    <div>
        <ColumnsSelector
            ref="product-overview-columns"
            :fields="fields"
            :active-fields="activeFields"
            @activate="activateColumn"
            @inactivate="inactivateColumn"
        />
        <b-card no-body>
            <div class="card-header">
                <div>
                    <b-card-title>{{ $t('Page(ProductOverview):Component(Text):page_title') }}</b-card-title>
                </div>
                <div>
                    <Button
                        class="btn-icon mr-1"
                        @click="clearFilter"
                    >
                        {{ $t('Component(Button):clear-filter') }}
                    </Button>
                </div>
                <div class="d-flex align-items-center">
                    <b-form-checkbox
                        v-model="compositionRootScopeEnabled"
                        class="mr-1"
                    >
                        {{ $t('Page(ProductOverview):Component(Filter):composition-root-scope') }}
                    </b-form-checkbox>
                    <ColumnsSelectorButton class="mr-1" @click="showColumns"/>
                    <Button
                        class="btn-icon"
                        @click="gotoCreateProduct"
                    >
                        <feather-icon icon="PlusIcon" />
                    </Button>
                </div>
            </div>
            <ProductOverview
                ref="productOverviewGrid"
                :activeFields="sortedFields"
                :composition-root-scope-enabled="compositionRootScopeEnabled"
                @fieldsChange="updateActiveFields"
                @click="gotoProductCard"
            />
        </b-card>
    </div>
</template>
<script>
import { BCardText, BCard, BCardTitle, BButton, BFormCheckbox } from 'bootstrap-vue'
import {ProductAttribute, ProductCategorySelect, ProductOverview} from "@core/components/product";
import {ColumnsSelectorButton, ColumnsSelector} from "@core/components/common";
import activeTableColumns from "@core/mixins/active-table-columns";
import Button from "@core/components/common/Button.vue";
import {ProductBreadcrumbs} from "@core/domain/product";

export default {
    mixins: [activeTableColumns],
    components: {
        Button,
        BCard,
        BCardText,
        BButton,
        BFormCheckbox,
        ProductAttribute,
        ProductCategorySelect,
        ProductOverview,
        BCardTitle,
        ColumnsSelectorButton,
        ColumnsSelector,
    },
    data() {
        const productOverviewSettings = this.$store.getters.runtimeConfig.productOverviewSettings;
        const scopeProductIds = productOverviewSettings && productOverviewSettings.filter
            ? productOverviewSettings.filter.compositionRootProductIds || []
            : [];

        return {
            fields: [],
            activeFields: [],
            compositionRootScopeEnabled: productOverviewSettings
                ? Boolean(productOverviewSettings.compositionRootScopeEnabled || scopeProductIds.length > 0)
                : false,
        };
    },
    methods: {
        clearFilter() {
            this.$refs.productOverviewGrid.clearFilter();
        },

        showColumns() {
            this.$refs['product-overview-columns'].show();
        },

        gotoCreateProduct() {
            this.$router.push({name: 'product-new-wizard'});
        },

        gotoProductCard(product) {
            this.$router.push({name: 'product-card', params: {id: product.id, product: product}, props: {}});
        },

        initFields() {
            this.fields = this.$refs['productOverviewGrid'].fields;
            this.initializeTableColumns(this.fields);
        },

        updateActiveFields() {
            this.initFields();
        }
    },
    computed: {
        sortedFields() {
            return this.activeFields.sort((a, b) => a.order - b.order);
        }
    },
    mounted() {
        ProductBreadcrumbs.clear();
        ProductBreadcrumbs.push(
            'Product overview',
            this.$t('Component(Sidebar):products-overview'),
            () => {
                this.$router.push({name: 'product-overview'});
            }
        );
        this.initFields();
    }
};
</script>
